import React from 'react';
import GenericModal from '../../../atoms/modals/GenericModal';
import ModalButton from '../../../atoms/modals/ModalButton';
import { Link } from 'react-router-dom';

import styles from './Auth.organisms.ExistingAccountModal.module.scss';
import i18n from 'i18n';


export class ExistingAccountModal extends React.Component {

    render() {
        const {
            handleIngresar,
            handleCancel,
            open
        } = this.props;

        const content = <div className={styles["existing-modal-container-content"]}>
                            <p className={styles["description"]}>{i18n.I18n("email.in.use")}.</p>
                            <Link style={{textAlign: 'center'}} to="/login" className={styles["link"]}><ModalButton label={i18n.t("login.into.my.account")} handleClick={handleIngresar}></ModalButton></Link>
                            <ModalButton label={i18n.t("cancel").toUpperCase()} handleClick={handleCancel}></ModalButton>

                        </div>
        return (
            <div>
                <GenericModal handleClose={this.handleCancel} content={content} open={open} title={i18n.t("existing.account")}></GenericModal>
            </div>
        )
    }

}


ExistingAccountModal.propTypes = {};

export default ExistingAccountModal;